export default [
    {
        path: '/website-navigations',
        props: true,
        component: () => import('@/views/WebsiteNavigation'),
    },
];
